import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { alertAdd, resetByMailPassword, logout } from "../../redux/actions";
import Grid from "@material-ui/core/Grid";
import LeftComponentMui from "../../left-component-mui";
import { Box } from "@material-ui/core";
import { LockOpen, Visibility } from "@material-ui/icons";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import styled from "styled-components";
import Can from "../../components/can";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import s from "../register-organization/index.module.css";
import Loader from "../../components/loader";
import { parse } from "qs";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { brand } from "../../theme";
import { usePasswordStrength } from "../../hooks/usePasswordStrength";
import { PasswordStrengthMeter } from "../../components/password-strength-meter";

const OrangeButton = styled(Button)`
  background-color: ${brand.teal};
  color: white;
`;

const CssTextField = withStyles((theme) => ({
  root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-input": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    "& .MuiInputLabel-outlined": {
      color: theme.palette.primary.main === "#fff200" && "#c2b90c",
    },
    "& .MuiInputLabel-outlined.Mui-focused": {
      color:
        theme.palette.primary.main === "#fff200" && theme.palette.primary.main,
    },
    backgroundColor: theme.palette.primary.main !== "#fff200" && "white",
    // border: theme.palette.primary.main !== "#fff200" && "1px solid lightgrey",
    borderRadius: "4px",
  },
}))(TextField);

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.text.primary,
  },
  iconSize: {
    "& .MuiAlert-icon": {
      fontSize: theme.typography.body1.iconSize,
    },
    fontSize: theme.typography.body1.iconSize,
  },
  hintText: {
    fontSize: theme.typography.body2.hintText,
    lineHeight: "1.4",
    // margin: "-5px auto 5px",
    color:
      theme.palette.primary.main === "#fff200"
        ? theme.palette.primary.main
        : "#999",
  },
}));

const PasswordResetMailPage = ({
  history,
  resettingByMailPassword,
  match: {
    params: { token },
  },
  location,
}) => {
  const classes = useStyles();
  const roles = useSelector((s) => s.roles);
  const globalTheme = useSelector((s) => s.globalTheme);
  const [newPassword, setNewPassword] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showNewPassword2, setShowNewPassword2] = useState(false);
  const [formIsValid, setFormIsValid] = useState(false);

  const {
    score: passwordScore,
    requirements: passwordRequirements,
  } = usePasswordStrength(newPassword);

  const [encodedToken, setEncodedToken] = useState(null);

  const dispatch = useDispatch();

  const role = parse(location.search.substring(1)).role;

  useEffect(() => {
    const t = JSON.parse(atob(decodeURIComponent(token)));
    setEncodedToken(t);

    if (role === "user") {
      const now = new Date();

      const tokenIsValid = new Date(t.validUntil) > now;
      if (!tokenIsValid) {
        history.push("/password-reset-link-expired");
      } else {
        history.push(`/password-set-new/${token}?role=user`);
      }
    }
  }, [token]);

  useEffect(() => {
    setFormIsValid(
      newPassword &&
        newPassword2 &&
        newPassword === newPassword2 &&
        passwordScore > 4
    );
  }, [newPassword, newPassword2, passwordScore]);

  useEffect(() => {
    if (!(roles[0] === "GUEST")) {
      // history.push("/password-reset-link-expired");
      roles.find((role) => role === "ROLE_USER")
        ? dispatch(logout({ isUser: true }))
        : dispatch(logout({ isUser: false }));
    }
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    if (!newPassword || newPassword !== newPassword2) {
      dispatch(
        alertAdd({
          text: "Nowe hasło i jego powtórzenie muszą być identyczne.",
          isError: true,
        })
      );
      return;
    }

    if (passwordScore <= 4) {
      dispatch(
        alertAdd({
          text:
            "Nowe hasło nie spełnia polityki silnego hasła: minimum 8 znaków, wielka i mała litera, cyfra oraz znak specjalny z zestawu ! @ # $ % ^ & + =.",
          isError: true,
        })
      );
      return;
    }

    const success = await dispatch(
      resetByMailPassword({
        email: encodedToken.email,
        resetId: encodedToken.resetId,
        role,
        newPassword,
      })
    );

    if (success) {
      dispatch(
        alertAdd({
          text: "Hasło zostało zmienione",
          isSuccess: true,
        })
      );
      history.push(role === "user" ? "/login" : "/login-employee");
    } else {
      dispatch(
        alertAdd({
          text: "Błąd zmiany hasła",
          isError: true,
        })
      );
    }
  };

  const cancel = (e) => {
    e.preventDefault();

    history.push(role === "user" ? "/login" : "/login-employee");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && formIsValid) {
      submit(e).then(r => {});
    }
  };

  const page = () => {
    return (
      <Grid
        container
        style={{
          minHeight: "100vh",
          backgroundColor: globalTheme === "high-contrast" ? "black" : undefined,
        }}
        direction="row-reverse"
      >
        <Grid item sm={12} xs={12} md={4}>
          <Box p={1}>
            <Box textAlign="center">
              <LockOpen />
            </Box>

            <Box as="h1" fontSize={20} textAlign="center">
              Resetowanie hasła
            </Box>

            <Loader
              loading={resettingByMailPassword}
              text="Resetuję hasło..."
            />

            <form onSubmit={submit} noValidate autoComplete="off">
              <Box>
                <CssTextField
                  label="Nowe hasło"
                  variant="outlined"
                  type={showNewPassword ? "text" : "password"}
                  value={newPassword}
                  fullWidth
                  onChange={(e) => {
                    setNewPassword(e.target.value);
                  }}
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          aria-label="toggle password visibility"
                        >
                          <Visibility
                            className={`${
                              globalTheme === "high-contrast" && classes.icon
                            } ${classes.iconSize}`}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <Box mt={2}>
                <CssTextField
                  label="Powtórz nowe hasło"
                  variant="outlined"
                  type={showNewPassword2 ? "text" : "password"}
                  value={newPassword2}
                  fullWidth
                  onChange={(e) => setNewPassword2(e.target.value)}
                  onKeyDown={handleKeyDown}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowNewPassword2(!showNewPassword2)}
                          aria-label="toggle password visibility"
                        >
                          <Visibility
                            className={`${
                              globalTheme === "high-contrast" && classes.icon
                            } ${classes.iconSize}`}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
              <PasswordStrengthMeter
                score={passwordScore}
                requirements={passwordRequirements}
                highContrast={globalTheme === "high-contrast"}
              />
              <Box mt={1} display="flex">
                <Button
                  variant={"contained"}
                  fullWidth
                  onClick={cancel}
                  className={classes.fontSize}
                  type="button"
                  style={{
                    marginLeft: "10px",
                    backgroundColor:
                      globalTheme === "high-contrast" ? "black" : "lightgrey",
                    color: globalTheme === "high-contrast" ? "yellow" : "black",
                    border:
                      globalTheme === "high-contrast" && "1px solid yellow",
                  }}
                >
                  Anuluj
                </Button>
                <OrangeButton
                  type="submit"
                  variant={"contained"}
                  fullWidth
                  disabled={!formIsValid}
                  className={classes.fontSize}
                  style={{
                    backgroundColor:
                      globalTheme === "high-contrast" ? "yellow" : brand.teal,
                    color: globalTheme === "high-contrast" ? "black" : "white",
                    border:
                      globalTheme === "high-contrast" && "1px solid yellow",
                  }}
                >
                  {newPassword === newPassword2
                    ? "Zmień hasło"
                    : "Hasła nie pasują do siebie"}
                </OrangeButton>
              </Box>
            </form>
          </Box>
        </Grid>

        <LeftComponentMui />
      </Grid>
    );
  };
  return (
    <Can
      permission="password-reset-email:view"
      ok={page}
      not={() => (
        <Loader
          loading={true}
          text="Przygotowywanie formularza zmiany hasła..."
        />
      )}
    />
  );
};

const mapStateToProps = (state) => ({
  resettingByMailPassword: state.resettingByMailPassword,
});

const mapDispatchToProps = (dispatch) => ({
  resetByMailPassword: (newPassword) =>
    dispatch(resetByMailPassword(newPassword)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PasswordResetMailPage);
